import React from "react";

import {
  formatPickQuickStatsExpectancy,
  formatPickQuickStatsPnl,
  formatPickQuickStatsTradeCount,
  formatPickQuickStatsWinRate,
  type PickQuickStats,
} from "../../../utils/reportPickQuickStats";

export type SimulatorPickQuickStatsProps = {
  stats: PickQuickStats | null | undefined;
};

export function SimulatorPickQuickStats({ stats }: SimulatorPickQuickStatsProps): React.ReactElement | null {
  if (!stats) return null;

  const items: Array<{ label: string; value: string }> = [
    { label: "PnL", value: formatPickQuickStatsPnl(stats.totalPnl) },
    { label: "Trades", value: formatPickQuickStatsTradeCount(stats.tradeCount) },
    { label: "Win rate", value: formatPickQuickStatsWinRate(stats.winRate) },
    { label: "Expectancy", value: formatPickQuickStatsExpectancy(stats.expectancy) },
  ];

  const visible = items.filter((item) => item.value !== "—");
  if (visible.length === 0) return null;

  return (
    <div
      data-simulator-picks-quick-stats=""
      className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 font-ibm-plex text-xs font-normal text-gray-500 dark:text-sidebar-muted-foreground"
    >
      {visible.map((item) => (
        <span key={item.label} className="whitespace-nowrap">
          <span className="text-gray-400 dark:text-sidebar-muted-foreground">{item.label}</span> {item.value}
        </span>
      ))}
    </div>
  );
}
